import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="469" height="277" viewBox="0 0 469 277" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h469v277H0z" />
      <path
        fill="#A2D65F"
        d="M286.835 140.786H263v-4.16h24.178l-5.809-6.992L284.07 127l8.466 10.19c.619.747.619 1.877 0 2.62L284.07 150l-2.7-2.634 5.465-6.58z"
      />
      <g transform="translate(335 104)">
        <path
          fill="#fff"
          d="M0 70V0h70v70H0zm44.374-55.388L35 41.045l-9.374-26.433h-12.07v40.776h9.587v-19.09l6.77 19.09h10.174l6.77-19.09v19.09h9.587V14.612h-12.07z"
        />
        <path
          fill="#51A2DA"
          d="M0 70V0h70v70H0zm44.374-55.388L35 41.045l-9.374-26.433h-12.07v40.776h9.587v-19.09l6.77 19.09h10.174l6.77-19.09v19.09h9.587V14.612h-12.07z"
        />
      </g>
      <path fill="#D7F2A5" d="M73 177h41v-42H73zM203 210h28v-34h-28z" />
      <path fill="#C9E59A" d="M198 277h64v-75h-64zM0 277h60v-60H0z" />
      <path fill="#B9D68E" d="M38 277h55V156H38zM160 276h55V171.046L160 125z" />
      <path fill="#B9D68E" d="M93 277h69V88H93z" />
      <path fill="#F4FFD9" d="M103 102h19v-4h-19zM127 102h19v-4h-19zM103 110h19v-4h-19z" />
      <path fill="#D7F2A5" d="M38 186h33v-4H38z" />
      <path fill="#F4FFD9" d="M38 178h33v-4H38z" />
      <path fill="#D7F2A5" d="M38 169h33v-4H38zM127 110h19v-4h-19z" />
      <path fill="#F4FFD9" d="M103 119h19v-4h-19zM127 119h19v-4h-19z" />
      <path fill="#D7F2A5" d="M103 126h19v-4h-19z" />
      <path fill="#F4FFD9" d="M162 193h20v-4h-20zM184 193h5v-4h-5zM192 178h5v-4h-5z" />
      <path fill="#D7F2A5" d="M192 185h5v-4h-5z" />
      <path fill="#F4FFD9" d="M192 193h5v-4h-5z" />
      <path fill="#D7F2A5" d="M162 178h20v-4h-20z" />
      <path fill="#F4FFD9" d="M184 178h5v-4h-5zM162 185h20v-4h-20z" />
      <path fill="#D7F2A5" d="M184 185h5v-4h-5z" />
      <path fill="#F4FFD9" d="M127 126h19v-4h-19zM103 134h19v-4h-19zM127 134h19v-4h-19z" />
      <path
        fill="#DCF7A9"
        d="M208.057 233.735V230h-15.191v8.784H187V258h18.809v-8.746H221v-15.519z"
      />
      <path stroke="#7BB934" strokeWidth=".953" d="M204 239v38M203 246h-7v5h2.905M203 242h7" />
      <path fill="#DCF7A9" d="M59.102 244.668V242H47.486v6.275H43V262h14.383v-6.247H69v-11.085z" />
      <g transform="translate(54 249)">
        <path stroke="#7BB934" strokeWidth=".953" d="M.524.08V28" />
      </g>
      <path stroke="#7BB934" strokeWidth=".953" d="M55 255h-6v4h2.49M55 250h5" />
      <path fill="#C9E59A" d="M186 114h25v-3h-25zM46 96h25v-3H46z" />
      <path fill="#D7F2A5" d="M39 93h25v-3H39z" />
      <path fill="#E1F9AC" d="M237 138h17v-3h-17z" />
      <path fill="#7BB934" d="M76 277h103v-67H76z" />
      <path fill="#F9F9F9" d="M81 256h58v-36H81z" />
      <path fill="#FFF" d="M80 260h62v-4H80z" />
      <path fill="#547F0F" d="M80 264h62v-4H80z" />
      <path fill="#7BB934" d="M76 209h103v-63H76z" />
      <path fill="#64991F" d="M83 167h89v-14H83zM76 208h103v-6H76z" />
      <path fill="#93D142" d="M81 277h59v-10H81z" />
      <path
        fill="#F9F9F9"
        d="M146 264h28v-40h-28zM146 277h28v-10h-28zM87 188h15v-15H87zM120 188h15v-15h-15zM153 188h15v-15h-15z"
      />
      <path fill="#A3EA47" d="M86 192h17v-4H86zM119 192h17v-4h-17zM152 192h17v-4h-17z" />
      <path fill="#FFF" d="M144 224h32v-4h-32z" />
    </g>
  </Svg>
)
